const SESSION_KEY = 'vuex'
const PEC_KEY = 'vuex-pec'

/**
 * Lê e converte um estado persistido.
 *
 * Remove o conteúdo quando o JSON estiver inválido.
 *
 * @param {Storage} storage
 * @param {string} key
 * @returns {{ value: string, state: Object }|null}
 */
function obterEstado(storage, key) {
  const value = storage.getItem(key)

  if (!value) {
    return null
  }

  try {
    return {
      value,
      state: JSON.parse(value),
    }
  } catch (error) {
    storage.removeItem(key)
    return null
  }
}

export const persistenceStorage = {
  /**
   * Recupera o estado persistido.
   *
   * @param {string} key
   * @returns {string|null}
   */
  getItem(key) {
    /*
     * O vuex-persistedstate pode utilizar chaves temporárias
     * durante a verificação do storage.
     */
    if (key !== SESSION_KEY) {
      return window.sessionStorage.getItem(key)
    }

    const sessaoPadrao = obterEstado(window.sessionStorage, SESSION_KEY)

    const sessaoPec = obterEstado(window.localStorage, PEC_KEY)

    const sessaoPadraoAutenticada =
      sessaoPadrao?.state?.origemLogin === 'default' &&
      Boolean(sessaoPadrao.state.accessToken)

    if (sessaoPadraoAutenticada) {
      return sessaoPadrao.value
    }

    const sessaoPecAutenticada =
      sessaoPec?.state?.origemLogin === 'pec' &&
      Boolean(sessaoPec.state.accessToken)

    if (sessaoPecAutenticada) {
      return sessaoPec.value
    }

    const sessaoPublicaPadrao = sessaoPadrao?.state?.origemLogin === 'default'

    if (sessaoPublicaPadrao) {
      return sessaoPadrao.value
    }

    return null
  },

  /**
   * Persiste o valor na chave solicitada.
   *
   * @param {string} key
   * @param {string} value
   * @returns {void}
   */
  setItem(key, value) {
    /*
     * Chaves diferentes de "vuex" são operações internas
     * do vuex-persistedstate, como o teste de disponibilidade.
     */
    if (key !== SESSION_KEY) {
      window.sessionStorage.setItem(key, value)
      return
    }

    try {
      const estado = JSON.parse(value)

      if (estado.origemLogin === 'pec') {
        window.localStorage.setItem(PEC_KEY, value)
        return
      }

      window.sessionStorage.setItem(SESSION_KEY, value)
    } catch (error) {
      console.error('Erro ao persistir o estado do Vuex:', error)
    }
  },

  /**
   * Remove exatamente a chave solicitada pelo plugin.
   *
   * @param {string} key
   * @returns {void}
   */
  removeItem(key) {
    window.sessionStorage.removeItem(key)
  },

  /**
   * Remove a sessão conforme a origem.
   *
   * Este método deve ser utilizado no logout.
   *
   * @param {'default'|'pec'} origemLogin
   * @returns {void}
   */
  removeSession(origemLogin) {
    if (origemLogin === 'pec') {
      window.localStorage.removeItem(PEC_KEY)
      return
    }

    window.sessionStorage.removeItem(SESSION_KEY)
  },

  /**
   * Remove todos os estados persistidos.
   *
   * @returns {void}
   */
  removeAll() {
    window.sessionStorage.removeItem(SESSION_KEY)
    window.localStorage.removeItem(PEC_KEY)
  },
}
